module.exports = __webpack_public_path__ + "img/background-bedroom-pc.0c16d82c.jpg";